import { WebDataRepository } from '../base/WebDataRepository';
import { IClusterRepository } from './IClusterRepository';
import { RemoteCluster } from '../../../../models/RemoteCluster';
import { AdvancedHttpClient } from '../../http/AdvancedHttpClient';
import { Utils } from '@kw-shared/common';
import { firstValueFrom, Observable } from 'rxjs';

export class ClusterRepository extends WebDataRepository<RemoteCluster> implements IClusterRepository {
  constructor(
    public override httpClient: AdvancedHttpClient,
    private basePath?: string
  ) {
    super(httpClient, Utils.joinPaths(basePath, 'cluster'));
  }

  public readClusters(wallboxId: string): Observable<RemoteCluster[]> {
    return this.httpClient.get<RemoteCluster[]>({ url: `${this.resource}/full/${wallboxId}` });
  }

  public setClusters(wallboxId: string, clusters: RemoteCluster[]): Promise<void> {
    return firstValueFrom(
      this.httpClient.put<void>({
        url: `${this.resource}/full/listUpdate/${wallboxId}`,
        body: { clusterSet: clusters },
      })
    );
  }
}
